import type { SVGProps } from 'react';

const SvgNoticeOffBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.29454 7.78974V18.3563C7.29454 19.2641 8.10332 20 9.101 20C10.0987 20 10.9074 19.2641 10.9074 18.3563V15.8293M6.52155 14.214L15.8425 18.0151C17.1998 18.515 18.6816 17.6061 18.6816 16.2739V5.88038C18.6816 4.54812 17.1998 3.63926 15.8425 4.13911L6.52154 7.94025C5.117 8.45754 3.68164 9.16588 3.68164 11.203C3.68164 12.9229 5.117 13.6967 6.52155 14.214Z'
      stroke='currentColor'
      strokeWidth={2}
    />
  </svg>
);
export default SvgNoticeOffBd;
